import React, { ChangeEvent, Component, createRef, RefObject } from 'react'
import InputLabel from './InputLabel'
import { SketchPicker, ColorResult } from 'react-color';

interface Props {
  name: string
  value: string
  label?: string
  className?: string
  onChange: (name: string, value: string) => void
}

interface InputColorState {
  color: string;
  displayColorPicker: boolean; 

}

export default class InputColor extends Component<Props,InputColorState> {
  inputRef: RefObject<SketchPicker>

  constructor (props: any) {
    super(props)
    this.inputRef = createRef<SketchPicker>();

    this.state = {
      color: '#fff',
      displayColorPicker: false, 
    };
  }

  get className () {
    const base = 'flex input-default cursor-pointer justify-between pr-0 items-center'
    return `${base} ${this.props.className}`
  }

  get color () {
    const style = { background: this.props.value }
    return <div className='h-full w-10' style={style}></div>
  }

  toggleColorPicker = () => {
    this.setState((prevState) => ({
      displayColorPicker: !prevState.displayColorPicker,
    }));
  };
 
  getColorPicker = () => {
    if (this.inputRef.current) {
      console.log('Current color in picker:', this.inputRef.current.props.color);
    }
  };

  resetValue (event: ChangeEvent<HTMLInputElement>) {
    event.target.value = ''
  }


  handleColorChange = (colorResult: ColorResult) => {
    this.setState({ color: colorResult.hex });
    this.props.onChange(this.props.name, colorResult.hex)
  };

  render () {

    const { color, displayColorPicker } = this.state;


    return (
      <div className="block">
        <InputLabel text={this.props.label} />
        <div
          className={this.className}
          onClick={this.toggleColorPicker}>
          <div>
              {displayColorPicker && (
              <SketchPicker
                color={color}
                onChange={this.handleColorChange}
                ref={this.inputRef}
              />
            )}
            {this.props.value}
          </div>
          {this.color}
        </div>
      </div>
    )
  }
}
